import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { fetchRadByRkun } from "../../../redux/actions/history";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import ActionDialog from "../../../components/ActionDialog";
import AccordionRads from "./AccordionRads";

type Props = {
  actFetchRadByRkun: ({ rkun_id }: any) => void;
  stateHistoryRad: any;
  open: boolean;
  setOpen: (open: boolean) => void;
};

const HistoryRadiologi = (props: Props) => {
  const { actFetchRadByRkun, stateHistoryRad, open, setOpen } = props;
  const { id } = useParams();

  React.useEffect(() => {
    if (open) actFetchRadByRkun({ rkun_id: id });
    return () => {};
  }, [open]);

  return (
    <>
      <ActionDialog
        open={open}
        label="Radiologi"
        setOpen={(val: boolean) => setOpen(val)}
      >
        <Stack spacing={2}>
          <Box height="1vh"></Box>
          {stateHistoryRad.length == 0 && (
            <Typography variant="body1" align="center">
              Data kosong
            </Typography>
          )}
          {stateHistoryRad?.map((item: any) => (
            <AccordionRads
              expertise={item.expertise}
              tanggal={item.tanggal}
              title={item.pemeriksaan}
              key={item.id}
              link={item.link}
            />
          ))}
        </Stack>
      </ActionDialog>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    stateHistoryRad: state.history.radiologi,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actFetchRadByRkun: ({ rkun_id }: any) =>
      dispatch(fetchRadByRkun({ rkun_id })),
    // actGetAntrianPoli: (id: number) => dispatch(getAntrianPoli(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryRadiologi);
